// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class TradingWebhookGroup extends PFixFieldSet {
    get id() {
        return super.GetValue(FieldsFactory.FIELD_ID);
    }
    get name() {
        return super.GetValue(FieldsFactory.FIELD_NAME);
    }
    get createdAt() {
        return super.GetValue(FieldsFactory.FIELD_CREATED_AT);
    }
    get expireAt() {
        return super.GetValue(FieldsFactory.FIELD_EXPIRE_AT);
    }
    constructor(pfixFieldSet) {
        super(FieldsFactory.TRADING_WEBHOOK_GROUP, null, pfixFieldSet);
    }
}
